import React, { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { ReportData } from '../types'
import { URL_API } from '../../../services/api_url'
import * as S from '../styles'

interface PDFDownloadButtonProps {
  reportData: ReportData | null
  isSystemReport?: boolean
  secret?: string
}

export const PDFDownloadButton: React.FC<PDFDownloadButtonProps> = ({
  reportData,
  isSystemReport = false,
  secret
}) => {
  const [generating, setGenerating] = useState(false)

  const handleDownloadPDF = async () => {
    if (!reportData) return

    setGenerating(true)

    try {
      let apiUrl: string
      const headers: Record<string, string> = {
        'Content-Type': 'application/json'
      }

      if (isSystemReport) {
        // System report endpoint with secret parameter
        if (!secret) {
          throw new Error('Chave secreta necessária para relatórios do sistema')
        }
        apiUrl = `${URL_API}/reports/system/comprehensive-report/pdf?secret=${secret}`
      } else {
        // User report endpoint with authentication
        const userStorage = localStorage.getItem('user')
        if (!userStorage) {
          throw new Error('Usuário não encontrado')
        }

        const user = JSON.parse(userStorage)
        const token = user.token
        const companyId = user.selectedContext?.companyId

        if (!token) {
          throw new Error('Token de autenticação não encontrado')
        }

        if (!companyId) {
          throw new Error('Contexto de empresa não selecionado')
        }

        apiUrl = `${URL_API}/reports/comprehensive-report/pdf?companyId=${companyId}`
        headers['Authorization'] = `Bearer ${token}`
      }

      // Call backend PDF generation endpoint
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers
      })

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Não autorizado. Verifique suas credenciais.')
        }
        throw new Error('Erro ao gerar PDF')
      }

      // Get PDF blob
      const blob = await response.blob()

      // Create download link
      const url = window.URL.createObjectURL(blob)
      const element = document.createElement('a')
      element.href = url

      // Set filename based on report type
      const reportType = isSystemReport ? 'system-report' : 'report'
      element.download = `proptoken-${reportType}-${
        new Date().toISOString().split('T')[0]
      }.pdf`

      // Trigger download
      document.body.appendChild(element)
      element.click()

      // Cleanup
      document.body.removeChild(element)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error generating PDF:', error)
      // Could show error toast here
      alert('Erro ao gerar PDF. Tente novamente.')
    } finally {
      setGenerating(false)
    }
  }

  return (
    <S.PDFButton
      onClick={handleDownloadPDF}
      disabled={!reportData || generating}
    >
      {generating ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          Gerando PDF...
        </>
      ) : (
        <>
          <i className="feather icon-download" />
          Baixar PDF
        </>
      )}
    </S.PDFButton>
  )
}
